<template>
	<div id="audit__filter__wrap"  :class="{'fixed-header-active':$store.state.isMobile && showAdvancedSearch}">
		    <div class="container-wrapper search-row-container-wrapper" id="audit-filters-container">
		      <div class="search-row-container container wide">
		          <div class="search-row">
		              <div class="search-row__search-bar search-bar-col">
		                  <b-input-group>
		                      <b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal"/>
		                      <b-input-group-append class="vdp-datepicker__search-button">
		                          <button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
		                      </b-input-group-append>
		                      <b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch">
		                          <button type="button" class="btn" @click="clearSearch();searchGlobal()">&times;</button>
		                      </b-input-group-append>
		                  </b-input-group>
		              </div>
		              <div class="search-row__filter-button d-flex hide-mobile">
		                  <div class="advance-search-filter" @click="toggleAdvancedSearch">
		                      <img src="/img/nav/icon-filter-dark-reverse.svg" alt="filter"  v-if="hasAdvancedFilters()" /><img src="/img/nav/icon-filter-dark.svg" alt="filter"  v-if="!hasAdvancedFilters()"/> FILTERS <span class="badge badge-secondary" v-if="1 == 2 && hasAdvancedFilters()" v-html="advancedFilterCount()"></span> <img src="../assets/downarrow.svg" alt="downarrow"
		                          :class="{'advance-arrow': true, 'up': showAdvancedSearch}" />
		                  </div>

		                  <button type="button" class="btn search-row__filter-clear-button hide-mobile"     v-if="hasAdvancedFilters()" @click="resetArgs()">
		                  	&times;<span v-html="resetText"></span>
		                  </button>
		              </div>
		          </div>
		      </div>
			  <h1 class="page-title mobile-only">Audit Logs</h1>
		   </div>
		   <div class="container-wrapper advance-search-container-wrapper" :class="{'expanded-wrapper': showAdvancedSearch}">
		            <div id="advance-search" :class="{'expanded': showAdvancedSearch, 'container':true, 'wide':true, 'advance-search-container':true}">
		                    <b-collapse :visible="showAdvancedSearch" class="advance-search-expandable">
		                        <b-row>
				    		<b-col md="auto">
				    			<b-form-group
				    			label="Date"
				    			label-size="sm"
				    			label-for="audit-log-date-from"
				    			>
				    			<div class="dates">
				    				<date-range-picker
				    					v-if="!$store.state.isMobile"
										v-model="filterDate"
										show-dropdowns
                         				opens="right"
										@update="onDateRangeSelect"
										:ranges="dateRangePickerRanges"
										:auto-apply="true"
										single-date-picker="range"
									>
									<template v-slot:input="picker" style="min-width: 350px;">
										<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
										</span>
										<span v-else>Start/End Date</span>
									</template>
								</date-range-picker>

				    				<date-range-picker
				    					v-if="$store.state.isMobile"
										v-model="filterDate"
										show-dropdowns
										opens="center"
										@update="onDateRangeSelect"
										:ranges="dateRangePickerRanges"
										:auto-apply="true"
										single-date-picker="range"
										:append-to-body="$store.state.isMobile"
									>
									<template v-slot:input="picker" style="min-width: 350px;">
										<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
										</span>
										<span v-else>Start/End Date</span>
									</template>
								</date-range-picker>
				    			</div>
				    		</b-form-group>
				    	</b-col>
				    	<b-col md="auto">
				    		<b-form-group
				    		label="Audit Type"
				    		label-size="sm"
				    		label-for="audit-log-type"
				    		>
				    		<b-form-select :id="`audit-log-type`" :options="auditTypeOptions"
				    		v-model="filterType.value"
				    		@input="toggleType()"
				    		:state="filterType.status"
				    		@change="toggleType"
				    		text-field="name"
				    		value-field="id"
				    		>
				    	</b-form-select>
				    </b-form-group>
				    </b-col>

		                            <b-col id="search-col">
		                                <div class="search-col__button-wrapper d-flex">
		                                <b-button id="search-btn" size="sm" @click="setArgs">Search</b-button>
		                                <b-button class="ml-3" variant="danger" id="reset-filter" @click="resetArgs()" v-if="hasAdvancedFilters() && $store.state.isMobile"> Reset</b-button>
		                                </div>
		                            </b-col>
		                        </b-row>
		                    </b-collapse>
		            </div>

		</div>

		<div class="quick-switch-container-wrapper hide-mobile">
		<div class="quick-switch-container container wide">
		    <div class="quick-switch">
		        <div class="quick-switch__title-standalone" v-html="title"></div>
		        <button class="quick-switch__action-button btn btn-secondary" @click="exportCSV">
		        	<template v-if="!downloading">Download</template> <b-spinner small label="Saving..." class="ml-2" v-if="downloading"></b-spinner>
		        </button>
		        </div>
		</div>
		</div>

</div>
</template>

<script>
import Vue from 'vue'
import AuditLog from './../models/AuditLog'
import BootstrapField from './../utility/BootstrapField';
import AuditLogList from '../models/AuditLogList';
import Format from './../utility/Format';
import moment from 'moment-timezone';

export default {
	name: 'AuditLogFilters',
	components: {
	},
	props: {
		columns: Array,
		totals: Object,
		activeList: Number,
		callOptionMethod: String,
		downloading: Boolean,
		title:String,
		storeArgs:String,
		storeModule:String,
	},
	data: () => ({
		AuditLogList: AuditLogList,
		showAdvancedSearch: false,
		showLaneFilter: false,
		arg: {},
		globalSearch: null,
		AuditLog,
		filterType: new BootstrapField({
			value: null,
		}),
		filterDate: {
			startDate: null,
			endDate: null,
		},
	}),
	mounted() {
		Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', this.hasAdvancedFilters());
		Vue.prototype.$bus.$emit('menu:advanceFiltersCount', this.advancedFilterCount());
		this.getAdvancedSearch();
	},
	created() {
		Vue.prototype.$bus.$off('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		Vue.prototype.$bus.$on('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		if ( this.columns ) {
			this.columns.forEach(item => {
				if ( item.filter ) {
					if ( (item.filter.autoComplete && item.filter.show) || (item.filter.datepicker && item.filter.show) ) {
						this.getArgs(item.filter)
					}
				}
			})
		}
	},

    watch: {
      'arg':function() {
         localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
      },
      'globalSearch': function() {
        this.arg['keywords'] = this.globalSearch;
        localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
        this.$emit('update:filters');
      }
    },
	computed: {
		resetText() {
		    if (this.advancedFilterCount() == 1) {
		      return "Reset " + this.advancedFilterCount() + " filter";
		    } else {
		      return "Reset " + this.advancedFilterCount() + " filters";
		    }
		},
		Totals() {
			let lists = []
			for (let item in this.totals) {
				if (item == "closures") {
					let attr = [],
					total = 0
					for (let key in this.totals[item]) {
						attr.push({
							name: key,
							count: parseInt(this.totals[item][key])
						})
						total += parseInt(this.totals[item][key])
					}
					lists.push({
						taskName: item,
						total,
						status: attr
					})
				}
			}
			return lists
		},

        dateRangePickerRanges() {
			return Format.getLocalDatePickerRanges();
        },

		auditTypeOptions() {
			let option = [
			{
				id: null,
				name: "All"
			}
			];

			option = option.concat(AuditLogList.getAuditTypeOptions);

			return option;
		}
	},
	methods: {
        formatDateRange(startDate,endDate) {
            let sd = this.$moment(startDate);
            let ed = this.$moment(endDate);
            return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
        },

        hasAdvancedFilters() {
			let response = false;
            for (let item in this.arg) {
                if (this.arg[item] != null  && item != "keywords" && item != "dateFrom" && item != "dateTo") {
                     response = true;
                }
            }
            if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    response = true;
                }
            }
			Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', response);
            return response;
        },

        advancedFilterCount() {
            let count = 0;
            for (let item in this.arg) {
                if (this.arg[item] != null && item != "completed" && item != "keywords" && item != "closureType" && item != "peakTime"
                    && item != "dateFrom" && item != "dateTo") {
                    if(item == "requesterProjectId") {
                        if (this.arg[item].id != null) {
                            count++;
                        }
                    } else {
                        count++;
                    }
                }
            }
            if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    count++;
                }
            }
			Vue.prototype.$bus.$emit('menu:advanceFiltersCount', count);
            return count;
        },
        handleAutocomplete(value, instanceId) {
            this.setArgs();
        },

        fieldId(name) {
            return this.storeArgs+"-field-"+name;
        },
		parseLabel(node, argAttr) {
			if ( node.label ) {
				if ( node.label.indexOf('(unknown)') > -1 ) {
					node.label = this.arg[argAttr]
				} else {
					this.arg[argAttr] = node.label
				}
			}
			return node.label
		},

		clickOutsideAdvanceSearch(e) {
			let filterBox = document.getElementById('audit-filters-container');
			let advanceSearchBox = document.getElementById('advance-search');
			let keepOpen = false;
			if (advanceSearchBox) {
			  if (advanceSearchBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (filterBox) {
			  if (filterBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (!keepOpen) {
			  this.hideAdvanceSearch();
			}
		},
		toggleAdvancedSearch() {
		  this.showAdvancedSearch = !this.showAdvancedSearch
		  Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
		  this.saveAdvancedSearch();
		  if(!this.$store.state.isMobile) {
			this.$nextTick(() => {
				if (this.showAdvancedSearch) {
				window.addEventListener('click', this.clickOutsideAdvanceSearch);
				}
				else {
				window.removeEventListener('click', this.clickOutsideAdvanceSearch);
				}
			});
		  }
		},

		hideAdvanceSearch() {
		  if (this.showAdvancedSearch) {
		    this.showAdvancedSearch = false;
		    window.removeEventListener('click', this.clickOutsideAdvanceSearch);
		  }
		},

		saveAdvancedSearch() {
			localStorage.setItem('showAdvancedSearch', this.showAdvancedSearch)
		},
        getAdvanceSearchColumnClasses(field) {
          return 'advance-search__'+field;
        },
		getAdvancedSearch() {
			this.showAdvancedSearch = false;
			/*
			let testValue = localStorage.getItem('showAdvancedSearch');
            if (testValue == "true") {
				this.showAdvancedSearch = true;
			} else {
				this.showAdvancedSearch = false;
			}
			*/
		},
        getOptionSelected(qty) {
          if (qty == 1) {
            return qty + " option selected";
          } else {
            return qty + " options selected"
          }
        },

		searchGlobal() {
			this.arg['keywords'] = this.globalSearch
			this.setArgs()
			this.$emit('submit:filters')
		},

		getArgValues(keyField, label) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeFilter))
			if (argQuery == null) {
				argQuery = {};
			}

            if (argQuery != null) {
			if ( !Array.isArray(argQuery) ) {
				if ( argQuery[keyField] ) {
					this.arg[keyField] = argQuery[keyField]
				}
			}
			if ( !this.arg[keyField] ) {
				this.arg[keyField] = {}
				if ( label ) {
					this.arg[keyField][label] = ''
				}
			}
                }
		},


		clearArgs( filters ) {
			this.arg = {
				...this.arg,
				[filters.key]: null,
				[filters.key+'_label']: null
			}
		},
		getArgs( filters ) {
			// console.log("getArgs");
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
			}
            // if ( this.arg === undefined )

			if ( filters.autoComplete ) {
				this.arg = {
					...this.arg,
                    [filters.key]: argQuery[filters.key]
				}
			} else if ( filters.datepicker ) {
				// console.log("get date");
				let startMoment = null;
				let endMoment = null;
				if (argQuery[filters.datepicker.from] != undefined) {
					startMoment = this.moment(argQuery[filters.datepicker.from]);
					if (startMoment.isValid()) {
					    startMoment.hours(0);
					    startMoment.minutes(0);
					    startMoment.seconds(0);
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.from]: startMoment.format(),
						}
						this.filterDate.startDate = new Date(startMoment.format());
					} else {
						argQuery[filters.datepicker.from] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.from]: null,
						}
						this.filterDate.startDate = null;
					}
				}
				if (argQuery[filters.datepicker.to] != undefined) {
					endMoment = this.moment(argQuery[filters.datepicker.to]);
					if (endMoment.isValid()) {
					    endMoment.hours(23);
					    endMoment.minutes(59);
					    endMoment.seconds(59);
					    this.arg = {
					        ...this.arg,
					        [filters.datepicker.to]: endMoment.format(),
					    }
					    this.filterDate.endDate = new Date(endMoment.format());
					} else {
						argQuery[filters.datepicker.to] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.to]: null,
						}
						this.filterDate.endDate = null;
					}
				}
				/*
                if (argQuery[filters.datepicker.from] != undefined) this.filterDate.startDate = new Date(argQuery[filters.datepicker.from]);
                if (argQuery[filters.datepicker.to] != undefined) this.filterDate.endDate = new Date(argQuery[filters.datepicker.to]);
                if (argQuery[filters.datepicker.from] == "Invalid date") {
                	argQuery[filters.datepicker.from] = null;
                	this.filterDate.startDate = null;
                }
                if (argQuery[filters.datepicker.to] == "Invalid date") {
                	argQuery[filters.datepicker.to] = null;
                	this.filterDate.endDate = null;
                }
				this.arg = {
					...this.arg,
					[filters.datepicker.from]: argQuery[filters.datepicker.from] != undefined ? argQuery[filters.datepicker.from] : null,
					[filters.datepicker.to]: argQuery[filters.datepicker.to] != undefined ? argQuery[filters.datepicker.to] : null,
				}
				*/
			}

			// pull in the global search and completed request filter.
            if (argQuery != null) {
				if (argQuery.keywords) {
					this.globalSearch = argQuery.keywords;
				} else {
					this.globalSearch = null;
				}
	            this.globalSearch = null;
	            // this.filterDate = { startDate: null, endDate: null };
	        }
		},
		setArgs() {
			this.showAdvancedSearch = false;
		  Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
			// console.log("setArgs");
			// console.log(this.arg);
			// console.log(this.storeArgs);

			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
			this.$emit('submit:filters')
		},
		resetArgs() {
			this.arg = Array()
			this.globalSearch = ""
			this.filterType = new BootstrapField({ value: null })
			this.filterDate = { startDate: null, endDate: null }
			this.$store.dispatch(this.storeModule+'/clearParams')
			this.columns.map(elem => {
				if (elem.filter != undefined ) {
					if (elem.filter.show) {
						this.clearArgs(elem.filter)
					}
				}
			})
			this.setArgs()
			this.showAdvancedSearch = false
			Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
			Vue.prototype.$bus.$emit('menu:advanceFiltersCount', 0);
			this.saveAdvancedSearch();
		},


		onDatePickerChange(input, keyField) {
			let dateString = null;

			if (input) {
				let theDate = moment.tz({
					year: input.getFullYear(),
					month: input.getMonth(),
					day: input.getDate(),
					hour: keyField == "dateTo" ? 23 : 0,
					minute: keyField == "dateTo" ? 59 : 0,
					second: keyField == "dateTo" ? 59 : 0
				}, Format.TIMEZONE);

			if (theDate.isValid()) {
					dateString = theDate.utc().format();
				}
			}

			this.arg = {
				...this.arg,
				[keyField]: dateString
			}

		},

		hasFilter() {
			return this.globalSearch || this.filterType.value != null || this.arg.dateFrom || this.arg.dateTo
		},
		toggleType() {
			this.filterType.resetStatus();
			this.arg['auditTypeId'] = this.filterType.value;
		},
		clearSearch() {
			this.globalSearch = null;
			this.searchGlobal();
		},
		exportCSV() {
			this.arg['keywords'] = this.globalSearch;
			this.setArgs();
			this.$emit('submit:csv');
		},

		onDateRangeSelect(date) {
			const startDate = date.startDate;
			const endDate = date.endDate;

            this.arg = {
                ...this.arg,
				dateFrom: startDate
					? Format.pickerDateToUtc(
						new Date(
							startDate.getFullYear(),
							startDate.getMonth(),
							startDate.getDate(),
							0, 0, 0
						)
					)
					: null,
				dateTo: endDate
					? Format.pickerDateToUtc(
						new Date(
							endDate.getFullYear(),
							endDate.getMonth(),
							endDate.getDate(),
							23, 59, 59
						)
					)
					: null
			};

            // this.setArgs()
            // this.$emit('submit:filters')
		},

	}
}
</script>
